import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { VehicleService, VehicleType } from '@uzurv/clara';
import { isNullOrUndefined } from '@uzurv/core';
import { ReplaySubject } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'uz-vehicle-type-filter',
  templateUrl: './vehicle-type-filter.component.html',
  styleUrls: ['./vehicle-type-filter.component.scss']
})
export class VehicleTypeFilterComponent implements OnInit, OnChanges {
  @Input() vehicleType: Array<VehicleType>;
  @Input() allowMultiSelect = false;

  @Output() vehicleTypeSelected: EventEmitter<Array<VehicleType>> = new EventEmitter();

  vehicleTypes: Array<VehicleType>;
  filteredVehicleTypes = new ReplaySubject<Array<VehicleType>>(1);
  vehicleTypeSelector = new UntypedFormControl();
  vehicleTypeFiltersControl = new UntypedFormControl();

  constructor(private vehicleService: VehicleService) {}

  ngOnInit() {
    this.vehicleService.getVehicleTypes().subscribe(vehicleTypes => {
      this.vehicleTypes = vehicleTypes;
      this.filteredVehicleTypes.next(this.vehicleTypes.slice());
    });

    this.vehicleTypeFiltersControl.valueChanges.subscribe(() => {
      this.filterVehicleTypes();
    });

    this.vehicleTypeSelector.valueChanges.pipe(filter(value => !isNullOrUndefined(value))).subscribe(() => {
      this.vehicleTypeSelected.emit(this.vehicleTypeSelector.value);
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['vehicleType'] && changes['vehicleType'].currentValue) {
      if (!Array.isArray(changes['vehicleType'].currentValue)) {
        this.vehicleTypeSelector.reset();
      } else {
        this.vehicleTypeSelector.setValue(changes['vehicleType'].currentValue, { onlySelf: true, emitEvent: false });
      }
    }
  }

  compareIds(o1: any, o2: any): boolean {
    if (isNullOrUndefined(o1) || isNullOrUndefined(o2)) {
      return false;
    }
    return o1.id === o2.id;
  }

  private filterVehicleTypes() {
    if (!this.vehicleTypes) {
      return;
    }
    // get the search keyword
    let search = this.vehicleTypeFiltersControl.value;
    if (!search) {
      this.filteredVehicleTypes.next(this.vehicleTypes.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the vehicle types
    this.filteredVehicleTypes.next(
      this.vehicleTypes.filter(vehicleType => (vehicleType.code.toLocaleLowerCase() + vehicleType.name.toLowerCase()).indexOf(search) > -1)
    );
  }
}
